import { useState } from "react";
import MarketplaceCard from "./../usuarios/MarketplaceCard";

export default function FormEditarUsuario({
  form,
  setForm,
  perfiles,
  onSave,
  onCancel,
  loading,
  marketplaces = [],
  usuarioId,
  post,
}) {
  const [savingMarketplaceId, setSavingMarketplaceId] = useState(null);

  const manejarCambioMarketplace = async (procesoId, activo) => {
    console.log("Cambio marketplace", { procesoId, activo, usuarioId }); 
    if (!usuarioId) return;

    const prevMarketplaces = [...form.marketplaces];

    setSavingMarketplaceId(procesoId);

    setForm((prev) => ({
      ...prev,
      marketplaces: prev.marketplaces.map((m) =>
        m.id === procesoId ? { ...m, activo } : m
      ),
    }));

    const payload = {
        UsuarioId: usuarioId,
        ProcesoId: marketplaces.find(m => m.id === procesoId)?.chainId || '',
        ProcesoName: marketplaces.find(m => m.id === procesoId)?.procesoNombre || '',
        Activo: activo,
      };
      console.log("Payload marketplace", payload); 
      await post("updateUsuarioMarketplace", payload);
      setSavingMarketplaceId(null);
  };

  return (
    <div className="bg-white p-6 shadow rounded-lg animate-fade-in mt-4">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="space-y-3">
          <div>
            <label># Empleado</label>
            <input
              type="text"
              value={form.numEmpleado}
              onChange={(e) => setForm({ ...form, numEmpleado: e.target.value })}
              className="form-control"
            />
          </div>

          <div>
            <label>Nombre</label>
            <input
              type="text"
              value={form.nombre}
              onChange={(e) => setForm({ ...form, nombre: e.target.value })}
              className="form-control"
            />
          </div>

          <div>
            <label>Email</label>
            <input
              type="email"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              className="form-control"
            />
          </div>

          <div>
            <label>Perfil</label>
            <select
              value={form.rolId}
              onChange={(e) => setForm({ ...form, rolId: e.target.value })}
              className="form-control"
            >
              <option value="">Seleccione un perfil</option>
              {perfiles.map((p) => (
                <option key={p.id} value={p.id}>
                  {p.name}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label>Estatus</label>
            <select
              value={form.estatusId}
              onChange={(e) =>
                setForm({ ...form, estatusId: e.target.value })
              }
              className="form-control"
            >
              <option value="">Seleccione un estatus</option>
              <option value="1">Activo</option>
              <option value="0">No activo</option>
            </select>
          </div>

          <div className="flex justify-end gap-2 mt-4">
            <button
              type="button"
              onClick={onCancel}
              className="btn btn-secondary"
            >
              Cancelar
            </button>

            <button
              type="button"
              onClick={onSave}
              disabled={loading}
              className="btn btn-primary"
            >
              {loading ? "Guardando..." : "Guardar"}
            </button>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
          {marketplaces.map((mp) => (
            <MarketplaceCard
              key={mp.id}
              id={mp.id}
              nombre={mp.procesoNombre}
              bgColor={mp.bgColor}
              textColor={mp.textColor}
              activoInicial={mp.activo}
              disabled={savingMarketplaceId === mp.id}
              onToggle={manejarCambioMarketplace}
            />
          ))}
        </div>

      </div>
    </div>
  );
}
